import styled from "styled-components";

export const Heading = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
  margin-bottom: 10px;
  gap: 6px;
  color: ${({ theme }) => theme.text.text};
  font-family: "PP Formula";
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: sticky;
  z-index: 10;
  bottom: -2px;
  padding: 60px 25px 30px;
  width: 105%;
  box-sizing: border-box;
  background: linear-gradient(
    to top,
    ${({ theme }) => theme.bg.general} 85%,
    transparent
  );
`;

export const SendButton = styled.div`
  display: flex;
  position: absolute;
  overflow: hidden;
  inset: 10px 10px 10px auto;
  margin: auto;
  height: 25px;
  padding: 5px;
  cursor: pointer;
  z-index: 1;
  border-radius: 50%;
  background: ${({ theme }) => theme.text.title};
  color: ${({ theme, isDisabled }) =>
    `${theme.text.inverse}${isDisabled ? "90" : "ff"}`};
`;

export const Border = styled.div`
  position: relative;
  overflow: hidden;
  padding: 2px;
  border-radius: 999px;
  background: ${({ theme, isActive }) => {
    if (isActive) return "linear-gradient(98deg, #003bff, #00afff, #00d1c3)";

    return theme.border.black15;
  }};
  background-size: 200% 200%;
  animation: BorderAnimation 3.5s ease infinite;

  * {
    font-family: "PP Formula";
  }

  @keyframes BorderAnimation {
    0% {
      background-position: 10% 0;
    }
    50% {
      background-position: 98% 100%;
    }
    100% {
      background-position: 10% 0;
    }
  }
`;

export const Textarea = styled.textarea`
  display: flex;
  resize: none;
  outline: none;
  box-sizing: border-box;
  width: 100%;
  line-height: 1.4;
  padding: 16px 80px 16px 25px;
  box-shadow: 0 1.5px 10px 0 #3f414226;
  border: none;
  border-radius: 999px;
  background: ${({ theme }) => theme.bg.general};
`;

export const Parameters = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;

  div[class$="control"]  {
    background: ${({ theme }) => theme.bg.primary};
    border-color: ${({ theme }) => theme.bg.primary};
    border-radius: 20px;
  }

  & > div {
    width: 100%;
  }
`;

export const Warning = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 11px;
  line-height: 15px;
  margin: 10px 0 -25px;
  height: 32px;
  color: ${({ theme }) => theme.text.text};
  font-family: "PP Formula";

  * {
    font-family: "PP Formula";
  }

  button:first-of-type {
    margin-left: 10px;
  }
`;
